var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87996 12.5466C6.75329 12.5466 6.62663 12.5 6.52663 12.4L2.47996 8.35329C2.28663 8.15996 2.28663 7.83996 2.47996 7.64662L6.52663 3.59996C6.71996 3.40662 7.03996 3.40662 7.23329 3.59996C7.42663 3.79329 7.42663 4.11329 7.23329 4.30662L3.53996 7.99996L7.23329 11.6933C7.42663 11.8866 7.42663 12.2066 7.23329 12.4C7.13996 12.5 7.00663 12.5466 6.87996 12.5466Z",
    fill: "#9186A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 8.5H2.94678C2.67344 8.5 2.44678 8.27333 2.44678 8C2.44678 7.72667 2.67344 7.5 2.94678 7.5H14.1668C14.4401 7.5 14.6668 7.72667 14.6668 8C14.6668 8.27333 14.4401 8.5 14.1668 8.5Z",
    fill: "#9186A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.72c56e2a7476e8fc99cd282b2d5eded6.svg";
export { ForwardRef as ReactComponent };